<!--
 * @Author: your name
 * @Date: 2021-12-29 12:31:21
 * @LastEditTime: 2022-12-28 17:08:43
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page1-wrapper">
        <div class="page-title">
            <img class="logo" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-20-14p426GR4fjfjP48K8.png" alt="" />
            <br>
            
        </div>
        <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-19-44xn57fRr44BedswCk6.png" class="start-icon animate__animated  animate__pulse animate__infinite">
        <img class='title-image' src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-20-02BfgtPBPagNoXiFe.png"/>
        <div class="report-info">
            <!-- <span>
                Hi， 亲爱的<span class="report-num">{{ reportData.erpName }}</span>同学<br>
                你来神灯已经有<span class="report-num"> {{ reportData.meetingDays }} </span>天了<br>
                <span class="report-num">{{ firstDate.month }}</span> 月<span class="report-num"> {{ firstDate.date }} </span>日是你今年第一次访问社区<br>
                从此开启了2022的技术之旅<br>
                你是知识之火中不可或缺的一股灯芯<br>
                你的点滴，神灯都记在心里...
            </span> -->
            <!-- <span>
                Hi， 亲爱的<span class="report-num">{{ reportData.erpName }}</span>同学<br>
                时光荏苒，岁月如梭。<br>
                <span class="report-num">{{ firstDate.month }}</span> 月<span class="report-num"> {{ firstDate.date }} </span>，你来到神灯<br>
                回首过去，那些在神灯的点点滴滴仿佛就在昨天，神灯见证了你的成长与进步。<br>
            </span> -->
            <span id="element"></span>
        </div>
        <div @click="handleNext" class="report-footer animate__heartBeat --animate__infinite" >
            <div>查看我的2023</div>
        </div>
    </div>
</template>
<script>
import Typed from 'typed.js';
import moment from 'moment';

export default {
    name: 'Page1',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    data() {
        return {
            showBtn: false
        }
    },
    computed: {
      firstDate() {
        const { loginFirstTime } = this.reportData
        if (loginFirstTime) {
            const [year, month, date] = loginFirstTime.split('-')
            return {
                year: +year,
                month: +month,
                date: +date
            }
        }
        return {
            year: '',
            month: '',
            date: ''
        }
      }
    },
    mounted() {
        const days = moment().diff(moment(this.reportData.loginFirstTime),'days');
        new Typed('#element', {
        showCursor: false,
        strings: [`Hi， 亲爱的<span class="report-num-text"> ${this.reportData.erpName} </span>同学<br>时光荏苒，岁月如梭<br><span class="report-num">${this.firstDate.year } </span>年<span class="report-num"> ${this.firstDate.month} </span> 月<span class="report-num"> ${ this.firstDate.date } </span>，我们相遇了<br>神灯已陪伴你走过<br><span class="report-num"> ${days} </span>天`],
        typeSpeed: 40,
        });
    },
    methods: {
        handleNext() {
            this.$emit('next');
        },
    },
};
</script>

<style lang="less">
#page1-wrapper {
    height: 100vh;
    width: 100%;
    color: #fff;
    text-align: center;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-29G6RrBmSO8CcHZjN.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    overflow: hidden;
    position: relative;
    .page-title {
        text-align: left;
        margin: 16px;
    }
    .title-image {
        height: 36px;
        margin-top: 1.5rem;
    }
    .logo {
        height: 36px;
    }
    .report-title {
        text-align: center;
        display: flex;
        // justify-content: center;
        padding: 1rem 24px 0;
        align-items: center;
        .report-plat {
            font-size: 0.6rem;
            margin-right: 0.3rem;
            font-weight: 500;
        }
        .report-year {
            font-size: 0.5rem;
            font-style: italic;
        }
    }
    .report-info {
        margin-top: 1rem;
        font-size: 0.4rem;
        line-height: 2.8;
        color: #FAFAD7;
        font-weight: bold;
        padding: 0 36px;
        // text-shadow: 1px 1px #f4e8e8;
        .report-num {
            color: #f1f406;
            font-size: 0.55rem;
            font-weight: 500;
        }
        .report-num-text {
            color: #f1f406;
            font-size: 0.45rem;
            font-weight: 500;
        }
    }
    .report-footer {
        position: fixed;
        bottom: 48px;
        padding: 10px 16px;
        border-radius: 10px;
        text-align: center;
        background: #736fd5;
        font-size: 15px;
        left: 50%;
        transform: translateX(-50%);
    }
    .slide {
        -webkit-animation: slideMove 1.5s linear 0s infinite;
        animation: slideMove 1.5s linear 0s infinite;
        z-index: 30;
        font-size: 0.5rem;
        cursor: pointer;
    }
    @keyframes slideMove {
        0% {
            transform: translateY(0.6rem);
            opacity: 0;
        }
        50% {
            transform: translateY(0.3rem);
            opacity: 0.8;
        }
        100% {
            transform: translateY(0);
            opacity: 0;
        }
    }
}
.cursor {
  color:inherit;
  position:relative;
  font:inherit;
  color:inherit;
  line-height: inherit;
  animation: Cursor 1s infinite;
}

@keyframes Cursor{
  0%{opacity: 1;}
  50%{opacity: 0;}
  100%{opacity: 1;}
}
.start-icon {
        position: absolute;
        top: 2rem;
        right: 16px;
        width: 1.2rem;
        height: 1.2rem;
    }

 @media screen and (min-width: 1980px) {
  #page1-wrapper {
    .report-title {
        margin-top: 3vh
    }
    .report-info {
        margin-top: 10vh;
    }
  }
}
</style>
